import React from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import { colorForNode, nameForNode, shortNameForNode } from './object-info/ObjectInfo';
import IpldExploreForm from './explore/IpldExploreForm';
import AboutIpld from './about/AboutIpld';
import ReactJoyride from 'react-joyride';
import { projectsTour } from '../lib/tours';

var ExploreSuggestion = function ExploreSuggestion(_ref) {
  var cid = _ref.cid,
      name = _ref.name,
      type = _ref.type;
  return /*#__PURE__*/React.createElement("a", {
    className: "flex items-center lh-copy pl3 pl0-l pv3 bb b--black-10 link focus-outline",
    href: "#/explore/".concat(cid)
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center justify-center w3 h3 flex-none br-100 tc",
    style: {
      background: colorForNode(type)
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "montserrat fw2 f4 snow",
    title: nameForNode(type)
  }, shortNameForNode(type))), /*#__PURE__*/React.createElement("span", {
    className: "pl3 truncate"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "ma0 fw4 f5 db black montserrat"
  }, name), /*#__PURE__*/React.createElement("span", {
    className: "f7 db blue truncate monospace"
  }, cid)));
};

var StartExploringPage = function StartExploringPage(_ref2) {
  var t = _ref2.t,
      embed = _ref2.embed,
      _ref2$runTour = _ref2.runTour,
      runTour = _ref2$runTour === void 0 ? false : _ref2$runTour,
      joyrideCallback = _ref2.joyrideCallback;
  return /*#__PURE__*/React.createElement("div", {
    className: "mw9 center explore-sug-2"
  }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, t('StartExploringPage.title'))), /*#__PURE__*/React.createElement("div", {
    className: "flex-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-auto-l mr3-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pl3 pl0-l pt4 pt2-l"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "f3 f2-l ma0 fw4 montserrat charcoal"
  }, t('StartExploringPage.header')), /*#__PURE__*/React.createElement("p", {
    className: "lh-copy f5 avenir charcoal-muted"
  }, t('StartExploringPage.leadParagraph'))), embed ? /*#__PURE__*/React.createElement(IpldExploreForm, null) : null, /*#__PURE__*/React.createElement("ul", {
    className: "list pl0 ma0 mt4 mt0-l bt bn-l b--black-10"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ExploreSuggestion, {
    name: "Project Apollo Archives",
    cid: "QmSnuWmxptJZdLJpKRarxBMS2Ju2oANVrgbr2xWbie9b2D",
    type: "dag-pb"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ExploreSuggestion, {
    name: "IGIS Git Repo",
    cid: "baf4bcfg4ep767tjp5lxyanx5urpjjgx5q2volvy",
    type: "git-raw"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ExploreSuggestion, {
    name: "An Ethereum Block",
    cid: "bagiacgzah24drzou2jlkixpblbgbg6nxfrasoklzttzoht5hixhxz3rlncyq",
    type: "eth-block"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ExploreSuggestion, {
    name: "XKCD Archives",
    cid: "QmdmQXB2mzChmMeKY47C43LxUdg1NDJ5MWcKMKxDu7RgQm",
    type: "dag-pb"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "pt2-l"
  }, /*#__PURE__*/React.createElement(AboutIpld, null))), /*#__PURE__*/React.createElement(ReactJoyride, {
    run: runTour,
    steps: projectsTour.getSteps({
      t: t
    }),
    styles: projectsTour.styles,
    callback: joyrideCallback,
    scrollToFirstStep: true
  }));
};
/* TODO: add dag-cbor and raw block examples
          <li>
            <ExploreSuggestion name='DAG-CBOR Block' cid='bafyreicnokmhmrnlp2wjhyk2haep4tqxiptwfrp2rrs7rzq7uk766chqvq' type='dag-cbor' />
          </li>
          <li>
            <ExploreSuggestion name='Raw Block for "hello"' cid='bafkreibm6jg3ux5qumhcn2b3flc3tyu6dmlb4xa7u5bf44yegnrjhc4yeq' type='raw' />
          </li>
*/


export default withTranslation('explore')(StartExploringPage);